<script>
  export let ToScrollID = "_AddReadingEl";

  function ScrollToId() {
    var element = document.getElementById(ToScrollID);
    element.scrollIntoView({ behavior: "smooth" });
  }
</script>

<div class="hero min-h-screen" style="background-image: url(https://i.imgur.com/rVlyLgc.jpg);">
  <div class="hero-overlay bg-opacity-60"></div>
  <div class="hero-content text-center text-neutral-content">
    <div class="max-w-md filter-none">
      <h1 class="mb-5 text-5xl font-bold lg:text-10xl">Calculate Height</h1>
      <p class="mb-5">This tool enables you to find the height of an object using a <a href="https://youtu.be/rVNhDZOwVU8" class="underline">Clinometer</a>, the mathametical steps which led to the answer as visible. Data is aggregated into a table for ease of access.</p>
      <div class="mt-3 space-x-4 inline-block align-middle">
        <button class="btn btn-primary" on:click={ScrollToId}>Get Started</button>
        <a href="https://codesandbox.io/s/gqz6vf" target="_blank"><button class="btn btn-outline btn-secondary">View Source</button></a>
      </div>
    </div>
  </div>
</div>